import { __decorate } from "tslib";
import { Vue, Component, Mixins } from "vue-property-decorator";
import { uiMapper } from "@/services/store/modules/ui/store";
import { dataMapper } from "@/services/store/modules/data/store";
import ItemCatalogue from "@/components/ItemCatalogue.vue";
const UiMappers = Vue.extend({
    computed: {
        ...uiMapper.mapState(["breakpoint"]),
    },
});
const DataMappers = Vue.extend({
    computed: {
        ...dataMapper.mapState(["courses"]),
    },
    methods: {},
});
let ScreenCatalogue = class ScreenCatalogue extends Mixins(UiMappers, DataMappers) {
    getBtnType(index) {
        switch (index) {
            case 0:
            case 5:
                return "blue-circle";
            case 1:
                return "orange-circle";
            case 2:
                return "magenta-circle";
            case 3:
                return "pink-circle";
            case 4:
                return "purple-circle";
        }
    }
};
ScreenCatalogue = __decorate([
    Component({
        components: {
            ItemCatalogue,
        },
    })
], ScreenCatalogue);
export default ScreenCatalogue;
